module.exports = __webpack_public_path__ + "static/media/img4.d9d21332.jpg";